import { tApi } from 'tplus-api';
/**
 * 获取促销方案的API
 */
export default class PromotionApi {
    static async getAllRetailPromotions(dto) {
        return await tApi({ retailDTO: dto }, 'chanjet.PR.IRetailPromotion.GetAllRetailPromotions');
    }

    //获取扫码的存货信息
    static async getInventoryData(idmember, Idstore, code, promotionType, cashBackWay, promotionObject, promotionDiscounts) {

        return await tApi({
            "idmember": idmember,
            "idStore": Idstore,
            "code": code,
            "promotionType": promotionType,
            "cashBackWay": cashBackWay,
            "promotionObject": promotionObject,
            "promotionDiscounts": promotionDiscounts,
            "serialNumberId": ''
        }, 'chanjet.PR.IRetailPromotion.GetInventoryData', false, false);
    }

    //获取一码多物的存货信息
    static async getInventoryInfo(idInventory, idmember, idStore,barCode,promotionType,cashBackWay,idUnit,serialNumberId) {
        return await tApi({
            "IdInventory": idInventory,
            "IdMember":idmember,
            "idStore": idStore,
            "BarCode": barCode,
            "promotionType": promotionType,
            "cashBackWay": cashBackWay,
            "idUnit":idUnit,
            "serialNumberId": serialNumberId
        }, 'chanjet.PR.IRetailPromotion.GetInventoryInfo', false, false);
    }

    //获取单品打折方案
    static async getSingleDiscount(idInventory,idunit,idmember, idStore) {
        return await tApi({
            "idInventory": idInventory,
            "idunit":idunit,
            "idMember":idmember,
            "idStore": idStore
        }, 'chanjet.PR.IRetailPromotion.GetSingleDiscountInfo', false, false);
    }

    //自助收银的促销执行
    static async selfSettlePromotion(dto) {
        return await tApi({ retailDTO: dto }, 'chanjet.PR.IRetailPromotion.SelfSettlePromotion');
    }

}
